import React from 'react';
import { useTranslation } from 'react-i18next';
import { CartIcon } from '../Icons';

function StickyBuyBar({ visible, onClick }) {
    const { t } = useTranslation();

    return (
        <div className={`mobile-sticky-buy-bar ${visible ? 'visible' : ''}`}>
            <button className="details-buy-btn shine-button" onClick={onClick}>
                <CartIcon /> {t('details.buyNow')}
            </button>
        </div>
    );
}

export default StickyBuyBar;
